import { render, staticRenderFns } from "./StaticRoutes.vue?vue&type=template&id=2c19be5a"
import script from "./StaticRoutes.vue?vue&type=script&lang=js"
export * from "./StaticRoutes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports